// extracted by mini-css-extract-plugin
module.exports = {"content":"ErrorPage-content","image":"ErrorPage-image","title":"ErrorPage-title","subtitle":"ErrorPage-subtitle","btn":"ErrorPage-btn"};